import styled from 'styled-components';

export const StyledCorporateValue = styled.section`
    position: relative;
    background: #152637;
    background-image: url("/images/static/why.jpg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    @media (max-width: 767px) {
        margin-right: 0 !important;
        padding-right: 15px !important;
    }

    .container {
        width: 100%;
        max-width: 100%;
        padding: 0;
    }

    p {
        color: white;
        font-weight: 400;
        font-size: 1rem; /* 16px ÷ 16 */
        line-height: 1.5rem; /* 24px ÷ 16 */
        letter-spacing: 0;
    }

    .m-0 {
        justify-content: space-between;
    }

    .counter-item {
        margin-bottom: 80px;
        counter-increment: count;
        position: relative;
        padding: 0 15px 0 30px;
        width: 45%;

        @media (max-width: 767px) {
            width: 100%;
        }

        &:before {
            content: counter(count, decimal);
            font-weight: 400;
            font-size: 1rem; /* 16px ÷ 16 */
            line-height: 1.5rem; /* 24px ÷ 16 */
            letter-spacing: 0;
            position: absolute;
            color: white;
            left: 0;
            top: 8px;
        }

        &:nth-of-type(odd) {
        }

        &:nth-of-type(even) {
        }

        h4 {
            margin: 0 0 20px 0;
            font-weight: 500;
            font-size: 2rem; /* 32px ÷ 16 */
            line-height: 2.25rem; /* 36px ÷ 16 */
            letter-spacing: 0;
            color: white;
        }

        p {
            color: white;
            font-weight: 400;
            font-size: 1rem; /* 16px ÷ 16 */
            line-height: 1.5rem; /* 24px ÷ 16 */
            letter-spacing: 0;
        }

        &:nth-last-child(1) {
            margin-bottom: 0;
        }

        &:nth-last-child(2) {
            margin-bottom: 0;
        }
    }

    @media (max-width: 991px) {
        .bg-text-one, .bg-text-two {
            font-size: 120px;
            line-height: 120px;
        }

        .bg-text-one {
            top: -60px;
            bottom: unset;
        }

        .bg-text-two {
            right: -5%;
            top: 120px;
            bottom: unset;
        }

        .counter-item {
            padding: 0 15px 0 115px;

            &:nth-child(3) {
                margin-bottom: 80px;
            }

            &:before {
                left: 15px;
            }
        }

        .container {
            padding-top: 0px;
        }
    }
    @media (max-width: 767px) {
        padding-bottom: 90px !important;
        .counter-item:before {
            left: 0;
        }

        .counter-item {
            margin-bottom: 40px !important;
            padding: 0 15px 0 30px;
        }
    }

`;
